import { ApiState } from './types'
import {
  ApiKeyActionType,
  CLOSE_API_KEY_MODAL,
  GENERATE_API_KEY_SUCCESSFULLY,
  OPEN_API_KEY_MODAL,
  USER_HAS_API_KEY,
  USER_HAS_NO_API_KEY,
} from '../actions/types'

const initialState: ApiState = {
  hasApiKey: false,
  apiKeyModal: false,
  apiKey: '',
}

const api = (state: ApiState | undefined, action: ApiKeyActionType) => {
  const currentState = state ?? initialState
  let nextState = {}
  switch (action.type) {
    case USER_HAS_API_KEY:
      nextState = {
        hasApiKey: true,
      }
      break
    case USER_HAS_NO_API_KEY:
      nextState = {
        hasApiKey: false,
      }
      break
    case OPEN_API_KEY_MODAL:
      nextState = {
        apiKeyModal: true,
      }
      break
    case CLOSE_API_KEY_MODAL:
      nextState = {
        apiKeyModal: false,
        apiKey: '',
      }
      break
    case GENERATE_API_KEY_SUCCESSFULLY:
      nextState = {
        apiKey: action.payload.apiKey,
        hasApiKey: true,
      }
      break
    default:
      return currentState
  }
  return { ...currentState, ...nextState }
}

export default api
